import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getCardsRequest = (cards: any[]) => {
  let cardsList: any[] = []
  cards.map((card) => {
    cardsList.push({
      cardType: card.type,
      cardScheme: card.scheme,
      domesticAllowed: card.isDomesticAllowed,
      internationalAllowed: card.isInternationalAllowed,
      premium: card.isPremium,
    })
  })
  return cardsList
}

const addEmsCardsReq = (entityId: string, data: any[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.saveCardList,
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entityId: entityId,
      cardDetails: getCardsRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addEmsCardsReq }
